export default {
  id: 201,
  title: 'Target #201 - Triple Zero',
  url: 'https://cssbattle.dev/play/201',
  colors: ['#998235', '#FCBE5C', '#0B2429'],
  solution:
    '<p a><p b><p c><style>body,p[b]{background:#998235}p[a],p[c]{background:#fcbe5c}p{position:fixed}p[a]{top:29;left:45;width:90;height:210;border-radius:25px;box-shadow:110px 0 #0b2429,220px 0 #fcbe5c}p[b]{top:59;left:75;width:30;height:150;box-shadow:110px 0 #998235,220px 0 #998235}p[c]{top:119;left:0;width:45;height:30;box-shadow:355px 0 #fcbe5c',
}
